import React, { FC, useEffect, useState } from 'react';
import { Region } from '@graphql/types';
import { useRegionsLazyQuery } from '../../Publication/Form/gql/PublicationEditor.generated';
import { Autocomplete, TextField } from '@mui/material';
import useDeviceDetect from '@utils/useDeviceDetect';
import CloseIcon from '@mui/icons-material/Close';

type RegionsPickerProp = {
    regions?: Region[] | null;
    handleChangeRegion: (newRegions: { id: string; title: string }[]) => void;
    selectedRegionUids?: string[];
    disabled?: boolean;
    width?: string;
    label?: string;
    marginBottom?: string;
};

const RegionsPicker: FC<RegionsPickerProp> = ({
    regions = null,
    handleChangeRegion,
    selectedRegionUids = [],
    disabled,
    width,
    label,
    marginBottom,
}) => {
    const [selectedValues, setSelectedValues] = useState<{ id: string; title: string }[]>([]);
    const [search, setSearch] = useState('');
    const { isMobile } = useDeviceDetect();
    const [getRegions, { data }] = useRegionsLazyQuery();
    const [fieldWidth, setFieldWidth] = useState(width || '315px');

    useEffect(() => {
        getRegions();
    }, [getRegions]);

    useEffect(() => {
        if (width) {
            setFieldWidth(width);
            return;
        }
        setFieldWidth(isMobile ? 'calc(100% - 20px)' : '315px');
    }, [width, isMobile]);

    useEffect(() => {
        if (data?.regions && selectedRegionUids.length > 0) {
            const matchedRegions = data.regions
                .filter((region) => selectedRegionUids.includes(region?.id || ''))
                .map((region) => ({
                    id: region?.id || '',
                    title: region?.title || '',
                }));
            setSelectedValues(matchedRegions);
        } else {
            setSelectedValues([]);
        }
    }, [data?.regions, selectedRegionUids]);

    const handleOnChange = (newValues: { id: string; title: string }[]) => {
        setSelectedValues(newValues);
        handleChangeRegion(newValues);
    };

    return (
        <Autocomplete
            multiple
            value={selectedValues}
            id={`regions-dropdown-tab`}
            inputValue={search}
            options={
                data?.regions?.map((region) => ({
                    id: region?.id || '',
                    title: region?.title || '',
                })) || []
            }
            getOptionDisabled={(option) => selectedRegionUids.includes(option.id)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.title}
            style={{ width: fieldWidth, marginBottom: marginBottom || '0px' }}
            onChange={(e, newValues) => handleOnChange(newValues)}
            onInputChange={(e, val) => setSearch(val)}
            renderInput={(params) => <TextField {...params} label={label || 'Регионы'} variant="outlined" />}
            disabled={disabled}
            clearIcon={<CloseIcon fontSize="small" />}
            noOptionsText={'Значений не найдено'}
        />
    );
};

export default RegionsPicker;